<template>
    <div>
        <div class="row">
            <product-item v-for="product in products"
                          :key="product.id"
                          :product="product"
                          :class="{
                              'col-xl-3 col-md-4 col-sm-6': true,
                              // 'col-lg-6 col-md-6':  [1, 2, 4].includes(products.length),
                              // 'col-lg-4 col-md-4 col-sm-6' : [3, 5, 6].includes(products.length),
                              // 'col-lg-3 col-md-4 col-sm-6' : products.length > 6,
                          }"
                          @click="onClickProductItem($event, product)"
            >
              <template #footer="{ product }">
                <slot name="product-item-footer" :product="product"></slot>
              </template>
            </product-item>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import ProductItem from '@/components/frontend/ProductItem.vue';

const { products, preventProductClick } = defineProps({
  products: {
    default: []
  },
  preventProductClick: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['click-product']);

const onClickProductItem = (e, product) => {
  if (preventProductClick) {
    e.preventDefault();
  }
  emit('click-product', product);
}

</script>